import { queryClient } from "@/query-client";
import { queryOptions, useMutation } from "@tanstack/react-query";
import type { CreateInvoicePrintTemplateData, UpdateInvoicePrintTemplateData } from "../../types/invoice-print-template";
import invoicePrintTemplateService from "../services/invoice-print-template-service";

const invalidate = () => queryClient.invalidateQueries({ queryKey: ["invoice-print-templates"] });

export const invoicePrintTemplatesQueryOptions = () =>
	queryOptions({
		queryKey: ["invoice-print-templates"],
		queryFn: () => invoicePrintTemplateService.list(),
	});

export const invoicePrintTemplateQueryOptions = (id: string) =>
	queryOptions({
		queryKey: ["invoice-print-templates", id],
		queryFn: () => invoicePrintTemplateService.findById(id),
		enabled: !!id,
	});

export const useInvoicePrintTemplateCreateMutation = () =>
	useMutation({
		mutationFn: (data: CreateInvoicePrintTemplateData) => invoicePrintTemplateService.create(data),
		onSuccess: invalidate,
	});

export const useInvoicePrintTemplateUpdateMutation = (id: string) =>
	useMutation({
		mutationFn: (data: UpdateInvoicePrintTemplateData) => invoicePrintTemplateService.updateById(id, data),
		onSuccess: invalidate,
	});

export const useInvoicePrintTemplateDeleteMutation = () =>
	useMutation({
		mutationFn: (id: string) => invoicePrintTemplateService.deleteById(id),
		onSuccess: invalidate,
	});

export const useInvoicePrintTemplateActivateMutation = () =>
	useMutation({
		mutationFn: (id: string) => invoicePrintTemplateService.activate(id),
		onSuccess: invalidate,
	});

export const useInvoicePrintTemplateBackgroundMutation = (id: string) =>
	useMutation({
		mutationFn: (file: File) => invoicePrintTemplateService.uploadBackground(id, file),
		onSuccess: invalidate,
	});
